import GetAdvanceSuccessScreen from 'features/advance/screens/advanceStatusScreens/GetAdvanceSuccess/GetAdvanceSuccessScreen';
import React from 'react';

export default function GetAdvanceSuccessPage() {
  return <GetAdvanceSuccessScreen />;
}
